var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "notes-container" },
    _vm._l(_setup.props.notes, function (note, index) {
      return _c(_setup.ReminderNoteComponent, {
        key: index,
        attrs: { note: note },
        on: {
          "edit-note": _setup.editNote,
          "show-remove-dialog": _setup.showRemoveDialog,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }